import bidiFactory from 'bidi-js';

const bidi = bidiFactory();

const RTL_CHARACTER_PATTERN = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;

export const hasRtlText = (text: string): boolean =>
    RTL_CHARACTER_PATTERN.test(text);

export const toVisualOrder = (line: string): string => {
    if (!hasRtlText(line)) {
        return line;
    }
    return bidi.getReorderedString(line, bidi.getEmbeddingLevels(line));
};
